export const FactRegistryABI = [
  {
    type: "function",
    name: "proposeFact",
    inputs: [
      {
        name: "oracleAddress",
        type: "address",
        internalType: "address"
      },
      {
        name: "key",
        type: "string",
        internalType: "string"
      },
      {
        name: "value",
        type: "string",
        internalType: "string"
      },
      {
        name: "source",
        type: "string",
        internalType: "string"
      }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "vote",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "support",
        type: "bool",
        internalType: "bool"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "executeProposal",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "forceApproveProposal",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "forceRejectProposal",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getPendingProposals",
    inputs: [],
    outputs: [
      {
        name: "proposalIds",
        type: "uint256[]",
        internalType: "uint256[]"
      },
      {
        name: "proposers",
        type: "address[]",
        internalType: "address[]"
      },
      {
        name: "oracleAddresses",
        type: "address[]",
        internalType: "address[]"
      },
      {
        name: "keys",
        type: "string[]",
        internalType: "string[]"
      },
      {
        name: "values",
        type: "string[]",
        internalType: "string[]"
      },
      {
        name: "timestamps",
        type: "uint256[]",
        internalType: "uint256[]"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getProposal",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [
      {
        name: "proposer",
        type: "address",
        internalType: "address"
      },
      {
        name: "oracleAddress",
        type: "address",
        internalType: "address"
      },
      {
        name: "key",
        type: "string",
        internalType: "string"
      },
      {
        name: "value",
        type: "string",
        internalType: "string"
      },
      {
        name: "source",
        type: "string",
        internalType: "string"
      },
      {
        name: "timestamp",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "stake",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "forVotes",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "againstVotes",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "status",
        type: "uint8",
        internalType: "enum FactRegistry.FactStatus"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "hasVoted",
    inputs: [
      {
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "voter",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [
      {
        name: "hasVoted",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "registerOracle",
    inputs: [
      {
        name: "oracleAddress",
        type: "address",
        internalType: "address"
      },
      {
        name: "domain",
        type: "string",
        internalType: "string"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "registeredOracles",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address"
      }
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "proposalCount",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "MIN_STAKE",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "VOTING_PERIOD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "QUORUM_THRESHOLD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "APPROVAL_THRESHOLD",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "FactProposed",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        indexed: true,
        name: "proposer",
        type: "address",
        internalType: "address"
      },
      {
        indexed: true,
        name: "oracleAddress",
        type: "address",
        internalType: "address"
      },
      {
        indexed: false,
        name: "key",
        type: "string",
        internalType: "string"
      },
      {
        indexed: false,
        name: "value",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "event",
    name: "VoteCast",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        indexed: true,
        name: "voter",
        type: "address",
        internalType: "address"
      },
      {
        indexed: false,
        name: "support",
        type: "bool",
        internalType: "bool"
      },
      {
        indexed: false,
        name: "weight",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "FactApproved",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "event",
    name: "FactRejected",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        indexed: false,
        name: "reason",
        type: "string",
        internalType: "string"
      }
    ]
  },
  {
    type: "event",
    name: "FactExecuted",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "proposalId",
        type: "uint256",
        internalType: "uint256"
      },
      {
        indexed: false,
        name: "oracleAddress",
        type: "address",
        internalType: "address"
      }
    ]
  }
] as const;

